import { createClient } from '@supabase/supabase-js';

const supabaseUrl = process.env.REACT_APP_SUPABASE_URL;
const supabaseAnonKey = process.env.REACT_APP_SUPABASE_ANON_KEY;

if (!supabaseUrl || !supabaseAnonKey) {
  console.warn('Supabase credentials not found');
}

export const supabase = createClient(
  supabaseUrl || '',
  supabaseAnonKey || '',
  {
    auth: {
      persistSession: true,
      autoRefreshToken: true,
    },
  }
);

// --- YARDIMCI: UUID KONTROLÜ (Burası harika, kalsın) ---
const safeUUID = (id) => {
  const uuidRegex = /^[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}$/;
  return id && uuidRegex.test(id) ? id : null;
};

// --- STORAGE ---
export const uploadImage = async (file, folder = 'listings') => {
  try {
    const fileName = `${Date.now()}-${Math.random().toString(36).substring(7)}-${file.name}`;
    const filePath = `${folder}/${fileName}`;

    const { error } = await supabase.storage
      .from('listings')
      .upload(filePath, file, { cacheControl: '3600', upsert: false });

    if (error) throw error;
    const { data: urlData } = supabase.storage.from('listings').getPublicUrl(filePath);
    return { filePath, publicUrl: urlData.publicUrl };
  } catch (error) { console.error('Upload error:', error); throw error; }
};

export const deleteImage = async (filePath) => {
  try {
    const { error } = await supabase.storage.from('listings').remove([filePath]);
    if (error) throw error;
    return true;
  } catch (error) { console.error('Delete error:', error); throw error; }
};

// --- LISTINGS (EKLEME - Senin düzeltiğin kısım, KORUNDU) ---
export const insertListing = async (rawListingData) => {
  console.log('--- INSERT İŞLEMİ BAŞLADI ---');
  try {
    const cleanData = {
        ...rawListingData,
        price: Number(rawListingData.price) || 0,
        rooms: rawListingData.rooms ? Number(rawListingData.rooms) : null,
        area: rawListingData.area ? Number(rawListingData.area) : null,
        floor: rawListingData.floor ? Number(rawListingData.floor) : null,
        total_floors: rawListingData.total_floors ? Number(rawListingData.total_floors) : null,
        
        user_id: safeUUID(rawListingData.user_id),
        agency_id: safeUUID(rawListingData.agency_id),
        complex_id: safeUUID(rawListingData.complex_id),
        
        images: Array.isArray(rawListingData.images) ? rawListingData.images : [],
        amenities: Array.isArray(rawListingData.amenities) ? rawListingData.amenities : []
    };

    const { data, error } = await supabase.from('listings').insert([cleanData]).select(); 
    if (error) throw error;
    return data && data.length > 0 ? data[0] : data;
  } catch (err) { console.error('Kod Hatası:', err); throw err; }
};

// --- FETCH LISTINGS (BEYAZ EKRANI ÇÖZEN KISIM BURASI) ---
export const fetchListings = async () => {
  try {
    // NOT: Admin panelinde 'Pasif' ilanları da görmek isteyebilirsin.
    // Eğer sadece aktifleri çekersen, onay bekleyenleri göremezsin.
    // Şimdilik çökmemesi için hepsini çekiyorum (.eq is_active filtresini kaldırdım veya güvenli hale getirdim)
    
    const { data, error } = await supabase
      .from('listings')
      .select('*')
      // .eq('is_active', true) // <-- Admin panelinde HEPSİNİ görmek için bunu kaldırmak daha iyi olabilir. Ama şimdilik hata vermemesi için kalsın diyorsan açabilirsin.
      .order('created_at', { ascending: false });

    if (error) throw error;

    // --- İŞTE SİHİRLİ DOKUNUŞ ---
    // Gelen veriyi tarıyoruz. Images NULL ise BOŞ LİSTE yapıyoruz.
    const safeData = (data || []).map(item => ({
        ...item,
        images: Array.isArray(item.images) ? item.images : [], // <-- Admin'i kurtaran satır
        amenities: Array.isArray(item.amenities) ? item.amenities : [],
        price: Number(item.price) || 0
    }));

    return safeData;
  } catch (error) {
    console.error('Fetch error:', error);
    return [];
  }
};

export const updateListing = async (id, updates) => {
  try {
    const { data, error } = await supabase.from('listings').update(updates).eq('id', id).select().single();
    if (error) throw error; return data;
  } catch (error) { console.error(error); throw error; }
};

export const deleteListing = async (id) => {
  try {
    if (!safeUUID(id)) return true;
    const { error } = await supabase.from('listings').delete().eq('id', id);
    if (error) throw error; return true;
  } catch (error) { console.error(error); throw error; }
};

// --- AGENCIES (Buna da koruma ekledim) ---
export const fetchAgencies = async () => {
  try {
    // Orijinal tablo: agencies
    const { data, error } = await supabase
      .from('agencies')
      .select('*')
      .order('created_at', { ascending: false });
    if (error) throw error;
    
    // Güvenli map ve logo_url -> logo alanı uyumu
    return (data || []).map(agency => ({
      ...agency,
      logo: agency.logo || agency.logo_url || '',
    }));
  } catch (error) { return []; }
};

export const insertAgency = async (agencyData) => {
  try {
    const { data, error } = await supabase.from('agencies').insert([agencyData]).select().single();
    if (error) throw error; return data;
  } catch (error) { throw error; }
};

export const deleteAgency = async (id) => {
  try {
    if (!safeUUID(id)) return true;
    const { error } = await supabase.from('agencies').delete().eq('id', id);
    if (error) throw error; return true;
  } catch (error) { throw error; }
};

export const fetchAgencyByAccessCode = async (accessCode) => {
  try {
    const { data, error } = await supabase
      .from('agencies')
      .select('*')
      .eq('access_code', accessCode)
      .eq('is_active', true)
      .single();
    if (error) return null; 
    return data;
  } catch (error) { return null; }
};

// --- COMPLEXES ---
export const fetchComplexes = async () => {
  try {
    const { data, error } = await supabase.from('complexes').select('*').order('created_at', { ascending: false });
    if (error) throw error; return data || [];
  } catch (error) { return []; }
};

export const insertComplex = async (complexData) => {
  try {
    const { data, error } = await supabase.from('complexes').insert([complexData]).select().single();
    if (error) throw error; return data;
  } catch (error) { throw error; }
};

export const deleteComplex = async (id) => {
  try {
     if (!safeUUID(id)) return true;
    const { error } = await supabase.from('complexes').delete().eq('id', id);
    if (error) throw error; return true;
  } catch (error) { throw error; }
};
